<template>
    <div class="w-full p-0 mb-8">
        <div class="summary-container flex bg-white flex-row content-between p-2">
            <div class="flex w-full" v-show="showSummary">
                <div class="flex flex-grow text-xl justify-start items-center p-2">
                    <span class="text-base font-roundo-bold">
                        <span class="text-viva-money-gray">Loan details:&nbsp;</span>
                        <span>£{{ thisFormattedAmount }} over {{ thisTerm }} months</span>
                    </span>
                </div>
                <div class="flex flex-grow justify-end items-center p-2 font-roundo-bold">
                    <button
                        type="button"
                        class="viva-drop-button amount-term"
                        @click="handleEditClick"
                    >Edit</button>
                </div>
            </div>
            <div class="flex w-full flex-wrap font-roundo-bold" v-show="!showSummary">
                <div class="flex w-full md:w-1/2 p-2">
                    <digi-currency
                        :attributes="{ maxlength: 5 }"
                        label="Loan amount"
                        name="loanamount"
                        v-model="thisAmount"
                        @input="handleInput"
                        @change="handleLoanAmountChange"
                        :rules="{ required: true, min_value: 100, max_value: this.loanAmountMax }"
                        class="mb-0 text-viva-money-black"
                    ></digi-currency>
                </div>
                <div class="flex w-full md:w-1/2 p-2">
                    <digi-select
                        :options="allowedTerms"
                        label="Preferred loan term"
                        name="term"
                        ref="term"
                        v-model="thisTerm"
                        :rules="{ required: true }"
                        @input="handleInput"
                        @change="handleLoanTermChange"
                        class="mb-0 text-viva-money-black"
                    ></digi-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DigiSelect from "./digi-select";
import DigiCurrency from "./digi-currency";
import { formatCurrency } from "./../../assets/js/form-functions";
import { pick, keys, first, last } from "underscore";
import { clamp, roundUpToNearest } from "../../assets/js/utils";
import { getAllAllowedTermsMap, getDropDownTerms, getAllowedTermsArray, getClosestAllowedTerm } from "../../assets/js/terms";

export default {
    computed: {
        thisFormattedAmount() {
            return formatCurrency(this.thisAmount);
        },
        allowedTerms() {
            let termKeys = getAllowedTermsArray(this.thisAmount);
            return pick(this.termOptions, termKeys);
        },
    },
    data() {
        return {
            loanAmountMax: 10000,
            thisAmount: this.customer.loanamount || this.form.default_loan_amount,
            thisTerm: this.customer.term || 12,
            showSummary: !this.expanded,
            termOptions: getDropDownTerms(),
        };
    },
    props: {
        queryparams: {
            type: Boolean,
            default: false,
        },
        customer: {},
        form: {},
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getRoundedAmount() {
            return clamp(roundUpToNearest(this.thisAmount, 50), 100, this.loanAmountMax);
        },
        handleEditClick() {
            this.showSummary = false;
            window.amplitude.loanSummaryEditEvent();
        },
        handleInput() {
            this.$set(this.customer, "loanamount", this.thisAmount);
            this.$set(this.customer, "term", this.thisTerm);
            this.$set(
                this.customer,
                "loanamount_formatted",
                this.thisFormattedAmount
            );
        },
        handleLoanAmountChange() {
            let roundedAmount = this.getRoundedAmount();
            if (this.thisAmount !== roundedAmount) {
                this.thisAmount = roundedAmount;
                this.$set(this.customer, "loanamount", this.thisAmount);
                this.$set(
                    this.customer,
                    "loanamount_formatted",
                    this.thisFormattedAmount
                );
                let closestAllowedTerm = getClosestAllowedTerm(this.thisAmount, this.thisTerm);
                if (closestAllowedTerm && closestAllowedTerm !== this.thisTerm) {
                    this.thisTerm = closestAllowedTerm;
                    window.amplitude.loanSummaryEditTermEvent(this.thisTerm + ' months');
                    this.handleInput();
                }
            }
            window.amplitude.loanSummaryEditAmountEvent('£' + this.thisAmount);
        },
        handleLoanTermChange() {
            window.amplitude.loanSummaryEditTermEvent(this.thisTerm + ' months');
        },
        checkQueryStringPrepop() {
            if (this.queryparams) {
                this.handleLoanAmountChange();
            }
        },
    },
    components: {
        "digi-select": DigiSelect,
        "digi-currency": DigiCurrency,
    },
    mounted() {
        this.handleInput();
        this.checkQueryStringPrepop();
    },
};
</script>

<style lang="scss">
.summary-container {
    background: #ffffff;
    box-shadow: -4px 4px 0px 0px black;
    border: 4px solid black;
    border-radius: 6px;
}
</style>